export default "__VITE_ASSET__IGS7ZafG__"